declare global {
  interface Window {
    notifications: Notifications;
  }
}

class Notifications {
  constructor() {
    this.init();
  }

  init() {
    window.notifications = this;
  }

  addNotification(title: string, message: string, type: 'success' | 'error') {
    const notification = document.createElement('div');
    notification.classList.add('notifications__item');
    notification.classList.add(`notifications__item--${type}`);
    // const titleElement = document.createElement('div');
    // titleElement.classList.add('notifications__title');
    // titleElement.classList.add('title');
    // titleElement.classList.add('fz--bigger');
    // titleElement.textContent = title;
    const textElement = document.createElement('div');
    textElement.classList.add('notifications__text');
    textElement.textContent = message;
    // notification.append(titleElement, textElement);
    notification.append(textElement);
    document.querySelector('.notifications')?.appendChild(notification);
    setTimeout(() => {
      notification.classList.add('notifications__item--show');
    }, 100);
    setTimeout(() => {
      notification.classList.remove('notifications__item--show');
    }, 5000);
    setTimeout(() => {
      this.removeNotification(notification);
    }, 5600);
  }

  removeNotification(notification: HTMLElement) {
    notification.remove();
  }

}

export default function notifications() {
  return new Notifications();
}